export const ts = {
    QR_CODE_COPY: {
        description: 'QR Modal copy',
        primaryValue: 'Here is your digital pass for access to your employee benefits. Click the button below to have it sent to your employee email.',
        stringKey: 'QR_CODE_COPY',
    },
    EMAIL_MY_PASS: {
        description: 'button on qr modal',
        primaryValue: 'Email My Pass',
        stringKey: 'EMAIL_MY_PASS',
    },
    EMPLOYEE_MY_PASS: {
        description: 'qr modal header',
        primaryValue: 'My Pass',
        stringKey: 'EMPLOYEE_MY_PASS',
    },
    SEND_QR_SUCCESS:{
        description: 'qr modal success message',
        primaryValue: 'An email with your QR Code will arrive shortly',
        stringKey: 'SEND_QR_SUCCESS',
    },
    SEND_QR_FAIL:{
        description: 'qr modal fail message',
        primaryValue: 'An error occurred while trying to send you a new QR Code',
        stringKey: 'SEND_QR_FAIL',
    },

};

